import React from 'react';
import { List } from 'semantic-ui-react'
// import {graphql} from 'react-apollo';

//utils
// import queries from '../../../src/utils/queries'

import TitDer from '../../../components/funcionales/titder';

// import EstilosHome from '../../css/home.css';

//Tarifas
const DetalleNivel1 = ({styles, elemento, handleClickidLista}) => {
  return(
    <tr className=''  onClick={(ev)=>handleClickidLista(ev, elemento)}>
      <td className=''>{elemento.codigoTarifa}</td>
      <td className=''>{elemento.descrTarifa}</td>
      <td className=''>{elemento.cicloFact}</td>
      <td className='' style={{color: elemento.estadoTarifa?'yellow':'#93291E', fontWeight: 'bold'}}>{elemento.estadoTarifa?'ACTIVA':'INACTIVA'}</td>
    </tr>
  )
};

const Lista = ({styles, list, handleClickidLista}) => {
  const nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 elemento={elemento} styles={styles}
    handleClickidLista={handleClickidLista} key={elemento._id}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

const ConfTar2 = ({autorizacUA, styles, handleClick, list, handleClickidLista}) => {
  const a251001 = autorizacUA.findIndex( autorizac => autorizac === "251001" );

  return (
    <div>
      <List selection>
        <TitDer list={list} textBoton1="Tarifas" btnNuevo={a251001!==-1?"SI":"NO"} styles={styles} handleClick={handleClick} />
        <div>
          <table className='ui blue inverted celled selectable table' style={styles.styTableSup}>
            <thead className=''>
              <tr className=''>
                <th className='' style={{width: '15%'}}>Código</th>
                <th className='' style={{width: '55%'}}>Descripción</th>
                <th className='' style={{width: '15%'}}>Ciclo de facturación</th>
                <th className='' style={{width: '15%'}}>Estado</th>
              </tr>
            </thead>
            <Lista styles={styles} list={list} handleClickidLista={handleClickidLista}/>
          </table>
          <p></p>
        </div>
      </List> 
    </div>
  )
};

export default ConfTar2
